/**
 * A product stores its category directly (`categoryId`) and, optionally, a sub
 * category under it. Products saved before the field existed only reach their
 * category through the sub category, so both readers fall back to that.
 */

type Ref = string | { _id?: string } | null | undefined;

const refId = (ref: Ref): string =>
  typeof ref === "string" ? ref : ref?._id ?? "";

/** The ids the Add/Edit Product form starts from. */
export function productCategoryIds(product: any): {
  categoryId: string;
  subCategoryId: string;
} {
  return {
    categoryId:
      refId(product?.categoryId) || refId(product?.subCategoryId?.categoryId),
    subCategoryId: refId(product?.subCategoryId),
  };
}

/** The category name the product list shows, "" when it has none. */
export function productCategoryName(product: any): string {
  return (
    product?.categoryId?.categoryName ??
    product?.subCategoryId?.categoryId?.categoryName ??
    ""
  );
}
